import { stringifyRelativeTimeDiff } from '../../time'
import { DAY, isEmpty, type BracketRound } from '@terros/common'
import { DateTime } from 'luxon'
import { type TranslateFunction } from '../../i18n'

export const getRoundLabel = (round: number, lastRoundNumber: number): string => {
  if (round === 0) return 'Seeding Round'
  if (round === lastRoundNumber) return 'Finals'
  if (round === lastRoundNumber - 1) return 'Semifinals'
  if (round === lastRoundNumber - 2) return 'Quarterfinals'
  return `Round ${round}`
}

export const stringifyRoundTimeline = (round: BracketRound): string => {
  const startDate = DateTime.fromMillis(round.startDate)
  const endDate = DateTime.fromMillis(round.endDate)
  return `${startDate.toLocaleString(DateTime.DATE_SHORT)} - ${endDate.toLocaleString(DateTime.DATE_SHORT)}`
}

export const getDefaultRoundDuration = (rounds: BracketRound[]): number => {
  if (isEmpty(rounds)) return DAY
  const firstRound = rounds.find((r) => r.round > 0)
  if (!firstRound) return DAY
  return firstRound.endDate - firstRound.startDate
}

export const stringifyRoundTimelineDiff = (round: BracketRound, t: TranslateFunction): string | undefined => {
  const now = DateTime.now().toMillis()
  const { startDate, endDate } = round

  // return `Starts in x days` if the round is in the future
  if (now < startDate) return `Starts ${stringifyRelativeTimeDiff(now, startDate, t)}`
  // return `Ended x days ago` if the round is completed
  if (now > endDate) return `Ended ${stringifyRelativeTimeDiff(now, endDate, t)}`
  // return `Ends in x days` if the round is in the past
  return `Ends ${stringifyRelativeTimeDiff(now, endDate, t)}`
}

const TIMELINE_FORMAT = DateTime.DATE_SHORT
export const toDisplayTimeline = (start: number, end: number): string => {
  const startDate = getDisplayStartDate(start)
  const endDate = getDisplayEndDate(end)
  return `${startDate.toLocaleString(TIMELINE_FORMAT)} - ${endDate.toLocaleString(TIMELINE_FORMAT)}`
}

export const getDisplayStartDate = (timeNumber: number): DateTime => {
  const time = DateTime.fromMillis(timeNumber)
  const startOfDay = time.startOf('day')
  if (time.hour > 12) {
    return startOfDay.plus({ day: 1 })
  }
  return startOfDay
}

export const getDisplayEndDate = (timeNumber: number): DateTime => {
  const time = DateTime.fromMillis(timeNumber)
  const endOfDay = time.endOf('day')
  if (time.hour < 12) {
    return endOfDay.minus({ day: 1 })
  }
  return endOfDay
}
